import { render, staticRenderFns } from "./CarrierMessages.vue?vue&type=template&id=323634e5"
import script from "./CarrierMessages.vue?vue&type=script&lang=js"
export * from "./CarrierMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports